import { ENV, IsPwaMode } from '@/constants/env'
// import { reloadPwa } from '@/main'
import { useQuery } from '@tanstack/react-query'
import { App, Button } from 'antd'

import axios from 'axios'
import { useEffect } from 'react'

export const useCheckAppVersion = () => {
  const { notification } = App.useApp()
  const res = useQuery({
    queryKey: ['version-app'],
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchInterval: 1000 * 10 * 60, // 10mins
    queryFn: () =>
      axios
        .get('/version.json', {
          headers: {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
            Expires: '0',
          },
        })
        .then(({ data }) => data as { gitHash?: string }),
  })
  useEffect(() => {
    if (!!res.data?.gitHash && !!ENV.VITE_GIT_HASH) {
      if (res.data?.gitHash !== ENV.VITE_GIT_HASH) {
        notification.info({
          title: 'New App version available',
          description:
            "We've just deployed a new version. Refresh now to enjoy the latest features and fixes!",
          showProgress: true,
          pauseOnHover: true,
          duration: 0,
          actions: (
            <Button
              onClick={() => {
                if (IsPwaMode) {
                  // reloadPwa(true)
                  return
                }
                window?.location?.reload()
              }}
              type="primary"
              size="middle"
            >
              Reload the app
            </Button>
          ),
        })
      }
    }
  }, [notification, res.data])
}
